import numeral from 'numeral'
import PropTypes from 'prop-types'
import React from 'react'

import { isNltBrumbrum } from '../../../utils/nltUtils'

const ServiziInclusi = ({ product, canone }) => {
  const { km_inclusi, fee_km } = canone || {}
  numeral.language('it')

  return (
    <div>
      <div className="servizi-inclusi">
        <h3 className="section-subtitle hide-small">
          Sempre inclusi nel canone
        </h3>
        <div className="box-elementi">
          <h5 className="section-title --reduced">Servizi</h5>
          <div className="elenco-servizi">
            {canone && km_inclusi && !isNltBrumbrum(product) ? (
              <div className="paragraph nome-servizio">
                <span className="icons icons-tick"></span>{' '}
                {numeral(km_inclusi).format('0[,]00')} km inclusi
              </div>
            ) : null}
            <div className="paragraph nome-servizio">
              <span className="icons icons-tick"></span> Soccorso stradale h24
            </div>
            <div className="paragraph nome-servizio">
              <span className="icons icons-tick"></span> Manutenzione completa
            </div>
            {!isNltBrumbrum(product) && (
              <div className="paragraph nome-servizio">
                <span className="icons icons-tick"></span> Consegna a domicilio
              </div>
            )}
            <div className="paragraph nome-servizio">
              <span className="icons icons-tick"></span> Copertura assicurativa
            </div>
          </div>
        </div>
      </div>
      {isNltBrumbrum(product) ? (
        <div className="servizi-inclusi">
          <div className="box-elementi">
            <h5 className="section-title --reduced">Condizioni Contrattuali</h5>

            <div className="elenco-servizi">
              <div className="paragraph nome-servizio">
                <span className="icons icons-tick"></span> Canone mensile fisso
              </div>

              {canone && fee_km && km_inclusi && isNltBrumbrum(product) ? (
                <div className="paragraph nome-servizio">
                  <span className="icons icons-tick"></span> Solo €{' '}
                  {numeral(fee_km).format('0[.]00')} al chilometro fino a{' '}
                  {numeral(km_inclusi).format('0[,]00')} km percorsi all'anno
                </div>
              ) : null}
            </div>
          </div>
        </div>
      ) : null}
    </div>
  )
}

ServiziInclusi.propTypes = {
  product: PropTypes.object,
}

export default ServiziInclusi
